import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {EditLineIcon} from '~library/svg/EditLineIcon';
import './TextEditorTooltip.sass';

export const TextEditorTooltip = ({isVisible = true, onClose}) => {
  if (!isVisible) return null;

  return (
    <div className="text-editor-tooltip" data-qa-id="text-editor-tooltip">
      <div className="text-editor-tooltip__main">
        <EditLineIcon ratio={0.75} />
        <div className="text-editor-tooltip__content">
          <Typography variant="list2" data-qa-id="text-editor-tooltip-title">
            Edit your text
          </Typography>
          <Typography variant="paragraph3" data-qa-id="text-editor-tooltip-subtitle">
            All font options will show when you tap Done.
          </Typography>
        </div>
      </div>
      <Button
        variant="unstyled-button"
        onClick={onClose}
        className="text-editor-tooltip__close"
        data-qa-id="text-editor-tooltip-close"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    </div>
  );
};
